import { EnvConfig } from './types/env.types'

export const env: EnvConfig = {
  baseUrl: 'https://api.beattractive.fr/',
  sentryDsn: 'https://c601aea1ba6144008e1e3885898f7755@o1300890.ingest.sentry.io/6549943',
  clientUuid: '39191fa4-c7df-4e45-8a82-80ef83b4922d',
  ENV: 'ciasRiveDroite',
  featureFlags: {
    areCheatCodesEnabled: false,
    isCodePushEnabled: false,
    isCodePushManual: false,
    isFavoritesEnabled: false,
  },
  matomoUrlBase: 'https://analytics.tools.citopia.fr/',
  matomoSiteId: 152,
  baseSurveyUrl: 'https://sondage.prod.tools.citopia.fr/survey',
}
